export const ONBOARDING_STATES = {
    USER_BIO: 'user_bio',
    INDUSTRY_INFO: 'industry_info',
    COMPANY_INFO: 'company_info',
    COMPANY_DETAILS: 'company_details',
    COMPANY_SIZE: 'company_size',
    INVITE_TEAM_MEMBERS: 'team_invite',
};
